// extracted by mini-css-extract-plugin
module.exports = {"logo":"app-nav-logo_logo__PhRqS"};